import { DeepPartial, AreaSeriesOptions, LineType, LineStyle, customSeriesDefaultOptions } from "lightweight-charts"
import { ChartColors, COLORS_STACKED, HISTOGRAM_COLORS, StackedAreaColor } from "../../models/colors.values"
import { StackedAreaSeriesOptions } from "../../options/lightweight-charts/stacked-area-series-plugin/options"
import { SeriesTypeEnum } from "../../models/series"

export const defaultSeriesOptions: DeepPartial<AreaSeriesOptions> = {
  title: '', priceFormat: { type: 'price', precision: 0 },
  lineType: LineType.Simple,
  lineStyle: LineStyle.Solid,
  pointMarkersVisible: false,
  crosshairMarkerVisible: false,
  lastValueVisible: false,
  priceLineVisible: false,
}

export const defaultStackedAreaSeriesOptions: StackedAreaSeriesOptions = {
  ...customSeriesDefaultOptions,
  colors: COLORS_STACKED.list as StackedAreaColor[],
  lineWidth: 2,
  lastValueVisible: false,
  priceLineVisible: false,
}

export const seriesOptionsMap = new Map<SeriesTypeEnum, DeepPartial<any>>([
  [SeriesTypeEnum.StackedArea, defaultSeriesOptions],
  [SeriesTypeEnum.Line, defaultSeriesOptions],
  [SeriesTypeEnum.Histogram, defaultSeriesOptions]
])

export const seriesColorMap = new Map<SeriesTypeEnum, ChartColors>([
  [SeriesTypeEnum.StackedArea, COLORS_STACKED],
  [SeriesTypeEnum.Line, HISTOGRAM_COLORS],
  [SeriesTypeEnum.Histogram, HISTOGRAM_COLORS],
])
